import React from 'react';
const _forEach = require('lodash/forEach');

export default class ChartBuilderSegmentingOptions extends React.Component{
  constructor(props){
    super(props)
    this.segmentOnSelect = React.createRef();
  };

  componentDidMount(){
    this.initSelect2();
    this._ismounted = true;
  };

  componentDidUpdate(prevProps){
    if(this.compareProps(prevProps)){
      $(this.segmentOnSelect.current).select2('destroy');
      _forEach($(this.segmentOnSelect.current).children(), (optionNode, key) => {
        optionNode.value && optionNode.value !== '' ? optionNode.remove() : null;
      });
      this.initSelect2();
    };

    if (this.props.error) {
      $(`#select2-${this.props.dataDetail.id}-segment-on-container`).addClass('has-errors');
    } else {
      $(`#select2-${this.props.dataDetail.id}-segment-on-container`).hasClass('has-errors') ? $(`#select2-${this.props.dataDetail.id}-segment-on-container`).removeClass('has-errors') : null;
    };

  };

  componentWillUnmount() {
    $(this.segmentOnSelect.current).select2('destroy');
  }

  render(){
    return(
      [
        <select key={`${this.props.dataDetail.id}-segment-on-select`} id={`${this.props.dataDetail.id}-segment-on`} ref={this.segmentOnSelect} className="form-control">
          {/* {
            this.props.dataDetail.segment_ids && this.props.dataDetail.segment_ids.length 
            ?
            this.setSelectedOptions()
            :
            this.defaultOption()
          } */}
        </select>,
        this.props.error
        ?
          <div className="help-block" key={`${this.props.dataDetail.id}-segment-on-error-block`}>
          <ul>{I18n.t('cant_be_blank')}</ul>
        </div>
        :
        null
      ]
    );
  };

  initSelect2(){
    $(this.segmentOnSelect.current).select2({
      id: (option) => { return option.id; },
      ajax: {
        url: `/admin/reports/data-sources/${this.props.dataSourceId}/segment_on/${this.props.segmentModel}/${this.props.segmentColumn}`,
        dataType: 'json',
        delay: 250,
        processResults: (response, params) =>{
          var selectOptions = response.data.map(option =>{
            return ({
              id: option.id,
              value: option.id,
              text: option[this.props.segmentColumn],
              selected: this.props.selectAll ? true : false,
            });
          });

          return {
            results: selectOptions,
          };
        },
        cache: false
      },
      allowClear: true,
      placeholder: I18n.t('select_ellipsis'),
      multiple: this.props.multipleSelect ? this.props.multipleSelect : false,
      // templateSelection:  (something) => {
      //   this.props.onChange(this.props.dataDetail.id, something.id, this.props.multipleSelect, something.text)
      // },
    })
      .on('select2:select', (e) => {
        this.props.onChange(this.props.dataDetail.id, e.params.data.id, this.props.multipleSelect, e.params.data.text)
    });
  };

  setSelectedOptions(){
    return this.props.dataDetail.segment_ids.map((id) => {
      return(
        <option key={`option-${id}`} value={id}  >{this.props.dataDetail.data_column_name.split('-')[1]}</option>
      )
    });
  };

  defaultOption(){
    if (this.props.multipleSelect){
      return null;
    } else {
      return <option></option>;
    };
  };

  compareProps(prevProps){
    if(prevProps.dataSourceId !== this.props.dataSourceId || prevProps.segmentModel !== this.props.segmentModel || prevProps.segmentColumn !== this.props.segmentColumn){
      return true
    } else {
      return false;
    };
  };

};